import { Colors } from 'web-common/src/shared/styles';

export const DEFAULT_SELECTED_COLOR = Colors.KOHLRABI;
export const DEFAULT_SELECTED_COLOR_HIGHLIGHT = Colors.KOHLRABI_LITE_40;
